// Contact.js
import React, { useState } from "react";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  // WhatsApp number
  const whatsappNumber = "+26771548257";

  // Function to encode message for WhatsApp
  const encodeWhatsAppMessage = () => {
    const { name, email, phone, message } = formData;
    const text = `New Contact Form Submission%0A%0AName: ${name}%0AEmail: ${email}%0APhone: ${phone}%0AMessage: ${message}`;
    return `https://wa.me/${whatsappNumber}?text=${text}`;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Open WhatsApp with encoded message
    window.open(encodeWhatsAppMessage(), "_blank");

    // Reset form
    setFormData({ name: "", email: "", phone: "", message: "" });

    // Show success message
    alert("Opening WhatsApp to send your message!");
  };

  // Handle input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <h1>Powering Botswana's Energy Future</h1>
          <p className="hero-subtitle">
            As Botswana's leading solar energy provider, we're committed to
            delivering sustainable, reliable, and affordable solar solutions.
            From residential installations to commercial solar farms, we power
            progress across the nation.
          </p>

          <div className="contact-hero-stats">
            <div className="stat-item-1">
              <span className="stat-number">500+</span>
              <span className="stat-label">Solar Installations</span>
            </div>
            <div className="stat-item-1">
              <span className="stat-number">24/7</span>
              <span className="stat-label">Expert Support</span>
            </div>
            <div className="stat-item-1">
              <span className="stat-number">98%</span>
              <span className="stat-label">Customer Satisfaction</span>
            </div>
            <div className="stat-item-1">
              <span className="stat-number">10+</span>
              <span className="stat-label">Years Experience</span>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        {/* Contact Form Section */}
        <div className="contact-header">
          <h1 className="contact-title">Contact Us</h1>
          <p className="contact-subtitle">
            Connect with our solar energy specialists for personalized solutions
          </p>
        </div>

        {/* WhatsApp Form */}
        <div className="whatsapp-form-full">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                required
                value={formData.name}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                required
                value={formData.email}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <input
                type="tel"
                name="phone"
                placeholder="Your Phone Number"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <textarea
                name="message"
                placeholder="Your Message"
                rows="5"
                required
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>

            <button type="submit" className="btn-submit">
              📱 Send via WhatsApp
            </button>

            <p className="form-note">
              Your message will be sent directly to our WhatsApp for faster
              response.
            </p>
          </form>
        </div>
      </div>

      {/* Full Width Map Section */}
      <div className="map-section-full">
        <div className="map-header">
          <div className="container">
            <h2>Our Location</h2>
            <p className="map-subtitle">
              Visit us at International Commerce Park, Gaborone
            </p>
          </div>
        </div>
        <div className="map-actions">
          <div className="container">
            <a
              href="https://www.google.com/maps/dir//Gaborone+International+Commerce+Park+Gaborone"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-directions"
              style={{ marginBottom: "20px" }}

            >
              📍 Get Directions on Google Maps
            </a>{" "}
            <br></br>
          </div>
        </div>
      </div>

      <iframe
        src="https://maps.google.com/maps?width=100%&height=500&hl=en&q=Gaborone%20International%20Commerce%20Park%20Gaborone+()&t=&z=12&ie=UTF8&iwloc=B&output=embed"
        width="100%"
        height="500"
        title="King Solarman Location"
        style={{ marginBottom: "-8px" }}

      ></iframe>
    </div>
  );
};

export default Contact;
